var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Paper',{staticClass:"p-4 d-flex justify-content-center",staticStyle:{"min-height":"160px"},attrs:{"slot":"right"},slot:"right"},[_c('img',{staticClass:"cute-logo",attrs:{"src":_vm.logo}})])}
var staticRenderFns = []

export { render, staticRenderFns }